import AppConstants from 'constants/AppConstants';

interface State {
  filterIsOpen: boolean;
}

const initialState: State = {
  filterIsOpen: false,
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type } = action;
  switch (type) {
    case AppConstants.CLOSE_RESERVATIONS_FILTER: {
      return {
        ...state,
        filterIsOpen: false,
      };
    }
    case AppConstants.OPEN_RESERVATIONS_FILTER: {
      return {
        ...state,
        filterIsOpen: true,
      };
    }
    default: {
      return state;
    }
  }
}
